import type { REVIEW_MENTION$options } from '$houdini';
import * as m from '$paraglide/messages';

const reviewMentionLabel: Record<REVIEW_MENTION$options, () => string> = {
	BAD: m.poi_card__review__bad,
	DISAPPOINTING: m.poi_card__review__disappointing,
	EXCEPTIONAL: m.poi_card__review__exceptional,
	FABULOUS: m.poi_card__review__fabulous,
	GOOD: m.poi_card__review__good,
	MEDIOCRE: m.poi_card__review__mediocre,
	PASSABLE: m.poi_card__review__passable,
	PLEASANT: m.poi_card__review__pleasant,
	QUITE_MEDIOCRE: m.poi_card__review__quite_mediocre,
	SUPERB: m.poi_card__review__superb,
	VERY_GOOD: m.poi_card__review__very_good,
	WELL: m.poi_card__review__well,
};
export function getReviewMentionTranslation(reviewMention: REVIEW_MENTION$options): string {
	return reviewMentionLabel[reviewMention]();
}
